module.exports = __webpack_public_path__ + "media/main_mov_v2_small.2838ef20.mp4";